import Vue from 'vue'
import Vuex from 'vuex'
import examination from './modules/index'
Vue.use(Vuex)

const store = new Vuex.Store({
	modules: {
		examination
	}
})
export default store
